import {
    FETCH_USER_REQUEST,
    FETCH_USER_SUCCESS,
    FETCH_USER_ERROR,
    HIDE_USER_LOADER,
    SHOW_USER_LOADER,
    CREATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_ERROR,
    CREATE_USER_RESET,
    GET_USER_ROLES_REQUEST,
    GET_USER_ROLES_SUCCESS,
    GET_USER_ROLES_ERROR,
    FETCH_ENTITY_LIST_REQUEST,
    FETCH_ENTITY_LIST_SUCCESS,
    FETCH_ENTITY_LIST_ERROR,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_ERROR,
    CREATE_ADMIN_USER_REQUEST,
    CREATE_ADMIN_USER_SUCCESS,
    CREATE_ADMIN_USER_ERROR,
    UPDATE_ADMIN_USER_REQUEST,
    UPDATE_ADMIN_USER_SUCCESS,
    UPDATE_ADMIN_USER_ERROR,
    UPDATE_USER_RESET,
    FETCH_USER_MAKER_REQUEST,
    FETCH_USER_MAKERS_SUCCESS,
    FETCH_USER_MAKERS_ERROR,
    FETCH_SYSTEM_USERS_REQUEST,
    FETCH_SYSTEM_USERS_SUCCESS,
    FETCH_SYSTEM_USERS_ERROR,
} from './userManagement.constants';

export const fetchSystemUsersRequest = payload => ({
    type: FETCH_SYSTEM_USERS_REQUEST,
    payload,
});

export const fetchSystemUsersSuccess = payload => ({
    type: FETCH_SYSTEM_USERS_SUCCESS,
    payload,
});

export const fetchSystemUsersError = payload => ({
    type: FETCH_SYSTEM_USERS_ERROR,
    payload,
});


export const fetchUserRequest = payload => ({
    type: FETCH_USER_REQUEST,
    payload,
});

export const fetchUserSuccess = payload => ({
    type: FETCH_USER_SUCCESS,
    payload,
});

export const fetchUserError = payload => ({
    type: FETCH_USER_ERROR,
    payload,
});

export const createUserRequest = payload => ({
    type: CREATE_USER_REQUEST,
    payload,
});

export const createUserSuccess = payload => ({
    type: CREATE_USER_SUCCESS,
    payload,
});

export const createUserError = payload => ({
    type: CREATE_USER_ERROR,
    payload,
});

export const createUserReset = payload => ({
    type: CREATE_USER_RESET,
});

export const updateUserReset = payload => ({
    type: UPDATE_USER_RESET,
});

export const getAllRolesRequest = () => ({
    type: GET_USER_ROLES_REQUEST,
});

export const getAllRolesSuccess = payload => ({
    type: GET_USER_ROLES_SUCCESS,
    payload,
});

export const getAllRolesError = payload => ({
    type: GET_USER_ROLES_ERROR,
    payload,
});

export const fetchEntityRequest = payload => ({
    type: FETCH_ENTITY_LIST_REQUEST,
    payload,
});

export const fetchEntitySuccess = payload => ({
    type: FETCH_ENTITY_LIST_SUCCESS,
    payload,
});

export const fetchEntityError = payload => ({
    type: FETCH_ENTITY_LIST_ERROR,
    payload,
});

export const updateUserRequest = payload => ({
    type: UPDATE_USER_REQUEST,
    payload,
});

export const updateUserSuccess = payload => ({
    type: UPDATE_USER_SUCCESS,
    payload,
});

export const updateUserError = payload => ({
    type: UPDATE_USER_ERROR,
    payload,
});

export const createAdminUserRequest = payload => ({
    type: CREATE_ADMIN_USER_REQUEST,
    payload,
});

export const createAdminUserSuccess = payload => ({
    type: CREATE_ADMIN_USER_SUCCESS,
    payload,
});

export const createAdminUserError = payload => ({
    type: CREATE_ADMIN_USER_ERROR,
    payload,
});

export const updateAdminUserRequest = payload => ({
    type: UPDATE_ADMIN_USER_REQUEST,
    payload,
});

export const updateAdminUserSuccess = payload => ({
    type: UPDATE_ADMIN_USER_SUCCESS,
    payload,
});

export const updateAdminUserError = payload => ({
    type: UPDATE_ADMIN_USER_ERROR,
    payload,
});

export const getUserMakersDetailsRequest = payload => ({
    type: FETCH_USER_MAKER_REQUEST,
    payload,
});

export const getUserMakersDetailsSuccess = payload => ({
    type: FETCH_USER_MAKERS_SUCCESS,
    payload,
});

export const getUserMakersDetailsError = payload => ({
    type: FETCH_USER_MAKERS_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_USER_LOADER });

export const hideLoader = () => ({ type: HIDE_USER_LOADER });
